export class CellphoneNotFoundError extends Error {
  constructor() {
    super("Provided cellphone was not found.");
    this.name = "CellphoneNotFoundError";
  }
}
